import React, { useEffect, useRef } from 'react';

const NotificationDetailModal = ({ notification, onClose }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);

    // Trap focus inside modal
    if (modalRef.current) {
      modalRef.current.focus();
    }

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  if (!notification) return null;

  const formatDate = (isoString) => {
    try {
      const d = new Date(isoString);
      return new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Kuala_Lumpur',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).format(d);
    } catch (e) {
      return '';
    }
  };

  const contextText = notification.visibility === 'ALL'
    ? 'ANNOUNCEMENT · ALL LEARNERS'
    : `ANNOUNCEMENT · ${notification.audienceLabel || 'SPECIFIC CLASS'}`;

  return (
    <div
      className="nc-modal-overlay"
      onClick={onClose}
      data-testid="notification-detail-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="nc-detail-title"
    >
      <div
        className="nc-modal-container"
        onClick={(e) => e.stopPropagation()}
        ref={modalRef}
        tabIndex={-1}
      >
        <div className="nc-modal-header">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
            <span className="nc-context-line" style={{ fontSize: '0.75rem', color: '#6B7780' }}>
              {contextText}
            </span>
            <h3 id="nc-detail-title">{notification.title}</h3>
          </div>
          <button
            type="button"
            className="nc-modal-close-btn"
            onClick={onClose}
            aria-label="Close details"
          >
            &times;
          </button>
        </div>

        <div className="nc-modal-body">
          <div className="nc-detail-meta">
            Posted by <strong>{notification.createdByName || 'Administrator'}</strong> · {formatDate(notification.createdAt)}
          </div>

          <div className="nc-detail-description" data-testid="notification-detail-description">
            {notification.description}
          </div>
        </div>

        <div className="nc-modal-footer">
          <button
            type="button"
            className="nc-btn-secondary"
            onClick={onClose}
            data-testid="notification-detail-close-btn"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationDetailModal;

